import type { Color } from "@mui/material";
import { Avatar } from "@mui/material";
import type { PropsWithChildren } from "react";
import { makeModeAwareAccentSurface } from "@entrilia/shared/utilities/colorHelper.ts";

interface Props {
  color: Color;
}

const StandardReportIconAvatar = ({ color, children }: PropsWithChildren<Props>) => (
  <Avatar variant="rounded" sx={(t) => makeModeAwareAccentSurface(t, color)}>
    {children}
  </Avatar>
);

export default StandardReportIconAvatar;
